import {TRANSFORMATION_STEP_TYPES} from 'analysis-tool/AnalysisToolConstants';
import {
  isSidebarDatasetInitializationSingleOutputStepType,
  isSidebarDatasetInitializationMultiOutputStepType,
} from 'analysis-tool/AnalysisTypes';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

/**
 * Step types that can be found at the beginning of a "view" table lineage.
 *
 * @package exported for testing
 */
export const VIEW_START_STEP_TYPES = [PipelineStepType.DATASET_VIEW];

/**
 * Step types that can be found in the middle (or end, in the case of a top-level table)
 * of a "top-level" or "view" table lineage.
 *
 * @package exported for testing
 */
export const TOP_LEVEL_OR_VIEW_INTER_STEP_TYPES = [
  ...TRANSFORMATION_STEP_TYPES,
  PipelineStepType.MAP_COLUMNS,
];

/**
 * Step types that can be found at the end of a "view" table lineage.
 *
 * @package exported for testing
 */
export const VIEW_END_STEP_TYPES = [
  PipelineStepType.REGRESSION,
  PipelineStepType.CHART_VIEW,
  PipelineStepType.TABLE_VIEW,
];

export function isTopLevelTableStartStepType(stepType: PipelineStepType): boolean {
  return (
    isSidebarDatasetInitializationSingleOutputStepType(stepType) ||
    isSidebarDatasetInitializationMultiOutputStepType(stepType)
  );
}

export function isViewStartStepType(stepType: PipelineStepType): boolean {
  return VIEW_START_STEP_TYPES.includes(stepType);
}

/** Return whether a step type starts a top-level OR view table lineage. */
export function isTableStartStepType(stepType: PipelineStepType): boolean {
  return isTopLevelTableStartStepType(stepType) || isViewStartStepType(stepType);
}

export function isTableInterStepType(stepType: PipelineStepType): boolean {
  return TOP_LEVEL_OR_VIEW_INTER_STEP_TYPES.includes(stepType);
}

export function isViewTerminalStepType(stepType: PipelineStepType): boolean {
  return VIEW_END_STEP_TYPES.includes(stepType);
}
